import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const topdesk = defineConnector({
  identifier: "topdesk",
  name: "TOPdesk",
  tagLine: "IT service management",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: ({ domain }) =>
    domain
      ? `https://${domain.replace(/\./g, "\\.")}/.*`
      : "https://[^/]*\\.topdesk\\.net/.*",
  auth: (app) =>
    basicAuth({
      username: app.config.username,
      password: app.secret.password,
    }),
  steps: [
    {
      title: "Enter your TOPdesk instance",
      items: [
        {
          kind: "input",
          label: "Instance domain",
          required: true,
          placeholder: "your-company.topdesk.net",
          target: { kind: "configuration", field: "domain" },
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Create an application password in TOPdesk under **My Settings › Application Passwords**. See the [API docs](https://developers.topdesk.com/) for details.",
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: { kind: "configuration", field: "username" },
        },
        {
          kind: "input",
          label: "Application password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/tas/api/incidents?pageSize=1`,
  },
});
